import React from 'react';

const Fullstack = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title">Fullstack Developer</h3>
            <div className="skills__box">
                <div className="skills__group">

                    <div className="skills__data">
                        <i class="devicon-html5-plain skills__icon"></i>
                        
                        <div>
                            <h3 className="skills__name">HTML</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i class="devicon-css3-plain skills__icon"></i>
                        <div>
                            <h3 className="skills__name">CSS</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>

                    <div className="skills__data">

                        <i class="devicon-javascript-plain skills__icon"></i>
                        <div>
                            <h3 className="skills__name">JavaScript</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <i class="devicon-react-original skills__icon"></i>
                        <div>
                            <h3 className="skills__name">React</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>

                    <div className="skills__data">
                        
                        <i class="devicon-tailwindcss-original skills__icon"></i>
                        <div>
                            <h3 className="skills__name">Tailwind</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>

                    <div className="skills__data">
                        
                        <i class="devicon-git-plain skills__icon"></i>
                        <div>
                            <h3 className="skills__name">Git</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>

                </div>
                <div className="skills__group">
                    <div className="skills__data">
                        <i class="devicon-dotnetcore-plain skills__icon"></i>
                        <div>
                            <h3 className="skills__name">.NET</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <i class="devicon-csharp-plain skills__icon"></i>
                        <div>
                            <h3 className="skills__name">C#</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <i class="devicon-python-plain skills__icon"></i>
                        <div>
                            <h3 className="skills__name">Python</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <i class="devicon-nodejs-plain skills__icon"></i>
                        <div>
                            <h3 className="skills__name">NodeJS</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <i class="devicon-sqldeveloper-plain skills__icon"></i>
                        <div>
                            <h3 className="skills__name">SQL</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <i class="devicon-mysql-original skills__icon"></i>
                        <div>
                            <h3 className="skills__name">MySQL</h3>
                            <span className="skills__level"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Fullstack;